import api from '../api';

// Saved settings for the signed-in user: UserPreferences on the server, so they
// follow the person to any computer, with a copy in this browser (per user)
// that shows at once while the server answers -- and is all there is until the
// server's table exists (it answers 503) or when it cannot be reached.

const localKey = (uid, key) => `pref:${uid}:${key}`;

export function readLocalPref(uid, key) {
  try { const v = localStorage.getItem(localKey(uid, key)); return v ? JSON.parse(v) : null; } catch { return null; }
}

function writeLocal(uid, key, value) {
  try { localStorage.setItem(localKey(uid, key), JSON.stringify(value)); } catch { /* not kept */ }
}

// The saved value, or null. One saved only in this browser (before the server
// could keep it) is copied up to the server.
export async function loadPref(uid, key) {
  try {
    const r = await api.get(`/api/preferences/${key}`);
    if (r.data.value != null) { writeLocal(uid, key, r.data.value); return r.data.value; }
    const mine = readLocalPref(uid, key);
    if (mine != null) api.put(`/api/preferences/${key}`, { value: mine }).catch(() => {});
    return mine;
  } catch {
    return readLocalPref(uid, key);
  }
}

// Saves at once in this browser; to the server a moment after the last change
// (a column drag sends one save, not one per step). Resolves true once the
// server has it, false when only this browser does.
const timers = {};
export function savePref(uid, key, value, delay = 800) {
  writeLocal(uid, key, value);
  clearTimeout(timers[key]);
  return new Promise((resolve) => {
    timers[key] = setTimeout(() => {
      api.put(`/api/preferences/${key}`, { value }).then(() => resolve(true), () => resolve(false));
    }, delay);
  });
}
